import { render, staticRenderFns } from "./Glossary.vue?vue&type=template&id=132f6e6e&scoped=true&"
import script from "./Glossary.vue?vue&type=script&lang=ts&"
export * from "./Glossary.vue?vue&type=script&lang=ts&"
import style0 from "./Glossary.vue?vue&type=style&index=0&id=132f6e6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132f6e6e",
  null
  
)

export default component.exports